module.exports = __webpack_public_path__ + "img/af1c422.png";